import * as React from 'react';
import PageTile from './pageTile';
import { classNames, addSlash } from '../../utils';
import Slider from 'react-slick';

const PageList = ({ data }) => {
  const isBrowser = typeof window !== 'undefined';
  const [isMobile] = React.useState(isBrowser ? window.innerWidth < 768 : false);
  const sliderSettings = {
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    infinite: false,
    arrows: !isMobile,
    dotsClass: 'slick-dots slider-dots',
    appendDots: (dots) => <ul className="slider-dots slick-dots"> {dots} </ul>,
    dots: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  switch (data.layout) {
    case 'List':
      const colsClass = data.pages.length > 2 ? 'grid-cols-12' : 'grid-cols-10';
      const colsSpanClass = data.pages.length > 2 ? 'col-span-12' : 'col-span-10';
      return (
        <div
          className={classNames('col-span-12 grid gap-6 page-list page-list--list-only mx-auto', colsClass)}
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.title && (
            <div className={colsSpanClass}>
              <h2 className="title">{data.title}</h2>
            </div>
          )}
          {data.pages.map((page, index) => {
            let tileClasses = 'col-span-10 md:col-span-5';
            if (data.pages.length > 2) {
              tileClasses = 'col-span-12 md:col-span-4';
            } else if (data.pages.length === 2) {
              if (index === 0) {
                tileClasses = 'col-span-10 md:col-span-5';
              } else {
                tileClasses = 'col-span-10 md:col-span-5';
              }
            }

            return (
              <PageTile
                key={`page-tile-${index}`}
                url={page.url}
                urltext={page.cta.urltext}
                image={page.cta.images[0]}
                title={page.cta.title}
                description={page.cta.description}
                classes={tileClasses}
                date_text={page.date_text || page.publish_details.date_text}
                date_number={page.date_number || page.publish_details.date_number}
              />
            );
          })}
          {data.url && data.urltext && (
            <div className={classNames(colsSpanClass, 'more')}>
              <a href={addSlash(data.url)}>{data.urltext}</a>
            </div>
          )}
        </div>
      );
    case 'Flex':
      return (
        <div
          className="col-span-12 flex flex-col space-y-6 space-x-none md:space-y-none md:space-x-6 md:flex-row justify-center items-start page-list page-list--flex"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.title && (
            <div className="w-full">
              <h2 className="title">{data.title}</h2>
            </div>
          )}
          {data.pages.map((page, index) => {
            return (
              <PageTile
                key={`page-tile-${index}`}
                url={page.url}
                urltext={page.cta.urltext}
                classes={'w-full md:w-1/4'}
                image={page.cta.images[0]}
                title={page.cta.title}
                description={page.cta.description}
                date_text={page.date_text || page.publish_details.date_text}
                date_number={page.date_number || page.publish_details.date_number}
              />
            );
          })}
          {data.url && data.urltext && (
            <div className="more">
              <a href={addSlash(data.url)}>{data.urltext}</a>
            </div>
          )}
        </div>
      );
    case 'ListTitlesOnly':
      return (
        <div
          className="col-span-12 w-full page-list page-list--titles-only"
          style={{
            backgroundColor: data.background_color ? data.background_color : 'transparent',
          }}
        >
          {data.title && (
            <div className="w-full container mx-auto">
              <h2 className="title">{data.title}</h2>
            </div>
          )}
          <div className="w-full flex flex-row flex-nowrap overflow-x-scroll overflow-y-hidden list-titles-only justify-between container mx-auto">
            {data.pages.map((page, index) => {
              return (
                <PageTile
                  key={`page-tile-${index}`}
                  url={page.url}
                  urltext={page.cta.urltext}
                  image={page.cta.images[0]}
                  link_image={true}
                  title={page.cta.title}
                />
              );
            })}
          </div>
          {data.url && data.urltext && (
            <div className="more">
              <a href={addSlash(data.url)}>{data.urltext}</a>
            </div>
          )}
        </div>
      );
    case 'Slider':
      return (
        <div className="col-span-12 page-list">
          <h2>{data.title}</h2>
          <div className="slider list-titles-only">
            <Slider {...sliderSettings}>
              {data.pages.map((page, index) => {
                return (
                  <PageTile
                    key={`page-tile-${index}`}
                    url={addSlash(page.url)}
                    urltext={page.cta?.urltext || 'LEARN MORE'}
                    image={page.cta?.images[0] || page.images[0]}
                    link_image={true}
                    title={page.cta?.title || page.title}
                  />
                );
              })}
            </Slider>
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default PageList;
